import "core-js/modules/es6.regexp.search";
import { _isGuid, _isInteger, parseQuery, windowExists } from '../helpers';
import { stringTuple } from '../stringTuple';
var queryKeys = stringTuple('caid', 'premiseId', 'selectedAddressId', 'selectedServiceId');
var derivedQueryKeys = stringTuple('contractAccountId', 'premiseId', 'selectedAddressId', 'selectedServiceId');

var queryState = function queryState() {
  var queryString = windowExists ? window.location.search : undefined;

  if (queryString) {
    var query = parseQuery(queryString);
    return normalizeAllowedQueryNumbers(query, queryKeys);
  } else {
    return {};
  }
};

var normalizeAllowedQueryNumbers = function normalizeAllowedQueryNumbers(query, allowedQueryKeys) {
  return allowedQueryKeys.reduce(function (obj, key) {
    var value = query[key];

    if (value && isValidQueryValue(value)) {
      // hack to map query string caid to contractAccountId
      var storageKey = key === 'caid' ? 'contractAccountId' : key;
      obj[storageKey] = value;
    }

    return obj;
  }, {});
};

var isValidQueryValue = function isValidQueryValue(value) {
  return _isInteger(value) || _isGuid(value);
};

export { queryState };